/*
 * @Copyright 2020. Institute for Future Intelligence, Inc.
 * @author Charles Xie
 */

import Smtp from "./js/smtp.js";

export class Email {

  private info = {};

  constructor() {
    this.info["Host"] = process.env.EMAIL_HOST;
    this.info["Username"] = process.env.EMAIL_USERNAME;
    this.info["Password"] = process.env.EMAIL_PASSWORD;
    this.info["From"] = process.env.EMAIL_USERNAME;
  }

  send(address: string, subject: string, body: string): void {
    this.info["To"] = address;
    this.info["Subject"] = subject;
    this.info["Body"] = body;
    Smtp.send(this.info);
  }

}
